// src/App.tsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Diagnosis from './pages/Diagnosis';
import DiagnosisResult from './pages/DiagnosisResult';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Diagnosis />} />
        <Route path="/result" element={<DiagnosisResult />} />
      </Routes>
    </Router>
  );
};

export default App;
